var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({staticClass:"auth_input_mfa",attrs:{"label":_vm.label,"prepend-inner-icon":_vm.prependInnerIcon,"type":"number","single-line":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }